import React, { Component } from 'react'
import Sidebar from 'layout/sidebar/sidebar'

import Dashboard from 'sections/dashboard/dashboard'
import Projects from 'sections/projects/projects'
import Status from 'sections/status/status'
import TeamIndex from 'sections/team/team-index'
import MeetingReporting from 'sections/reporting/meeting-reporting'
import Planning from 'sections/planning/planning'
import BigChat from 'components/big-chat/big-chat'

import { Switch, Route, Redirect } from 'react-router'
import { CSSTransitionGroup } from 'react-transition-group'

import isEqual from 'react-fast-compare'
import ValidationAlert from 'components/validation-alert/validation-alert'

import {
	isMobile,
	formatByTimeZone,
} from 'utils'

import moment from 'moment'

export default class Main extends Component {
	shouldComponentUpdate = nextProps => {
		// I don't think I should need this here.
		if (this.props.sidebarHidden !== nextProps.sidebarHidden) {
			return true
		}

		if (this.props.chatBehaviourTrigger !== nextProps.chatBehaviourTrigger) {
			return false
		}

		// Don't re-render when opening a headertab or modal
		if (!isMobile() && (this.props.activeHeaderTab !== nextProps.activeHeaderTab)) {
			return false
		}

		// Don't re-render when opening/closing a chat. It's already oddly expensive to do so.
		if (!isEqual(this.props.activeChats, nextProps.activeChats)) {
			return false
		}

		return true
	}

	shouldShowValidationAlert = _ => {
		const {
			userData,
			currentAccount,
		} = this.props

		if (userData && !userData.email_validated) {
			const hoursAgoAccountCreated = moment().diff(formatByTimeZone(userData.created_at, null, true), 'hours')

			if (hoursAgoAccountCreated > 2) {
				return 'email'
			}
		}

		if (currentAccount && currentAccount.package_id == 2 && !currentAccount.card_last_four && currentAccount.trial_ends_at) {
			const daysUntilTrialEnds = moment(currentAccount.trial_ends_at).startOf('day').diff(moment().startOf('day'), 'days')

			if (daysUntilTrialEnds > 0 && daysUntilTrialEnds < 3) {
				return daysUntilTrialEnds
			}
		}

		return false
	}

	render() {
		const {
			userData,
			sidebarHidden,
			toggleSidebar,
			currentAccount,
			folderChain,
			isGuest,
			thisUrl,
			userRoles,
			activeHeaderTab,
			isPremium,
			chatBehaviourTrigger,
			isChat,
			activeChats
		} = this.props

		const showValidationAlert = this.shouldShowValidationAlert()

		let mainClassName = sidebarHidden ? 'full-width' : ''

		if (showValidationAlert) {
			mainClassName += ' has-alert'
		}

		if ((activeHeaderTab && isMobile()) || !currentAccount) {
			return null
		}

		const routes = [
			{
				route: 'dashboard',
				Component: Dashboard,
				props: {
					isGuest,
					userData,
					currentAccount,
					folderChain
				}
			}, {
				route: 'projects',
				Component: Projects,
				props: {
					sidebarHidden
				}
			}, {
				route: 'people',
				Component: TeamIndex,
				props: {
					isGuest
				}
			}, {
				route: 'status',
				Component: Status,
				props: {
					isGuest
				}
			}, {
				route: 'reporting',
				Component: MeetingReporting,
			}, {
				route: 'planning',
				Component: Planning
			}, {
				route: 'chat',
				Component: BigChat,
			}
		]

		return (
			<div className={`main-container`}>
				{!isChat ?
					<Sidebar
						isGuest={isGuest}
						userData={userData}
						url={thisUrl}
						isHidden={sidebarHidden}
						toggleSidebar={toggleSidebar}
						userRoles={userRoles}
						activeHeaderTab={activeHeaderTab}
						isPremium={isPremium}
						chatBehaviourTrigger={chatBehaviourTrigger}
						accountData={currentAccount}
					/>
					: null}
				<main className={mainClassName}>
					{showValidationAlert ?
						<ValidationAlert reason={showValidationAlert} />
						: null}
					<CSSTransitionGroup transitionName="fade-in" transitionEnterTimeout={1000} transitionLeaveTimeout={1000}>
						<Switch>
							{routes.map(({
								route,
								Component,
								props = {}
							}) => (
								<Route key={route} path={`${thisUrl}/${route}`} render={routeProps => (
									<Component
										{...props}
										{...routeProps}
									/>
								)} />
							))}
							<Redirect to={thisUrl + '/dashboard'} />
						</Switch>
					</CSSTransitionGroup>
					<div id="single-task-portal" />
				</main>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/main/main.jsx